export interface iUnescaped {
  children: TrustedHTML | string;
}

function Unescaped({ children }: iUnescaped) {
  return <span dangerouslySetInnerHTML={{ __html: children }}></span>;
}

export default Unescaped;
